/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
export type OrderPaymentStatus = ('PaymentPending' | 'PaymentReceived' | '%future added value');
import type { FragmentReference } from 'relay-runtime';
declare export opaque type orderListNode$ref: FragmentReference;
export type orderListNode = {|
  +id: string,
  +currency_code: ?string,
  +currency_rate: ?number,
  +invoice_number: ?number,
  +order_date: ?any,
  +payment_due_date: ?any,
  +payment_status: ?OrderPaymentStatus,
  +total: ?number,
  +project_details: ?{|
    +brand: ?string,
    +product: ?string,
    +reference: ?string,
    +po_number: ?string,
    +notes: ?string,
  |},
  +$refType: orderListNode$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "orderListNode",
  "type": "Order",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "currency_code",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "currency_rate",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "invoice_number",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "order_date",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "payment_due_date",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "payment_status",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "total",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "project_details",
      "storageKey": null,
      "args": null,
      "concreteType": "ProjectDetails",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "brand",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "product",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "reference",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "po_number",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "notes",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node/*: any*/).hash = '4d7b3dbe197364bdc1bb219627198d0e';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/orderListNode.graphql.js